/* eslint-disable max-len */
export default {
  Title: 'Agreements',
  Subtitle: 'Please review and acknowledge the following to complete the registration. You must agree to the following to use our platform.',
  Items: {
    TermsOfService: {
      Label: 'Terms of Service Agreement',
      Description: 'I agree to the terms and conditions of service as outlined in the service agreement. <a href="https://carequilt.ca/Terms&Conditions" rel="noopener noreferrer" target="_blank">View Terms & Conditions</a>',
    },
    TruthfulInformation: {
      Label: 'Truthful Information',
      Description: 'I certify that all information provided during the registration process is truthful and accurate.',
    },
    Confidentiality: {
      Label: 'Confidentiality Agreement',
      Description: 'I agree to maintain the confidentiality of all client information and adhere to privacy policies.',
    },
    ValidQualifications: {
      Label: 'Valid Qualifications',
      Description: 'I certify that all my qualifications, certifications, and credentials are valid and current.',
    },
    ZeroTolerance: {
      Label: 'Zero Tolerance Policy',
      Description: 'I agree to the zero-tolerance policy for abuse and neglect of clients in my care.',
    },
    CodeOfConduct: {
      Label: 'Code of Conduct',
      Description: 'I agree to follow the organization\'s code of conduct and professional standards at all times.',
    },
  },
};
